// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3-Yoi","checkbox":"styles_checkbox__1ZiKd","icon":"styles_icon__1m1mQ","text":"styles_text__3-jXc"};